// 获取所有商品 type和id
export function getAllRecomIdObj(list) {
  let obj = {};
  list?.forEach((item) => {
    item.package_info?.forEach((info) => {
      // 非加价购
      if (!item.isAddPriceBuy) {
        obj[`${info.product_type}_${info.product_id}`] = true;
      }
    });
  });
  return obj;
}
